import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { connect } from 'react-redux';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { getPartByID } from '@reducers/parts';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { PartListOrSingleItem } from '@v2/pages/machines/modules/now/components/Part/components/PartListOrSingleItem';

interface NCFileDetailsPartProps {
  partId: number | null;
}

const NCFileDetailsPartComponent: FC<NCFileDetailsPartProps> = ({
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  getPartByID,
  getNCFileById,
  partId,
  operationsSearch,
  getNCFileByName,
}) => {
  const title = useTitle();

  const { partDataLoading } = useNCFileDetails({
    clearTools,
    getTools,
    updateHeaderConfig,
    getProductionBatchByNCFile,
    getPartByID,
    getNCFileById,
    operationsSearch,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.part}>
        <PartListOrSingleItem partDataLoadingForList={partDataLoading} partId={partId} />
    </DetailsPageWrapper>
  );
};

const NCFileDetailsPart = connect(({ details: { partId } }) => ({ partId }), {
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  getPartByID,
  getNCFileById,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsPartComponent);

export { NCFileDetailsPart };
